import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
`

export const TemplatesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const TemplateRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
`

export const TemplateBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
  flex: 1;
  padding: ${props => props.theme.spacing.sp16};
  border: ${props => props.theme.stroke.default} solid ${props => props.theme.colors.border.subtle};
  border-radius: ${props => props.theme.primitives.radius.radius2};
`

export const LoadMoreContainer = styled.div`
  display: flex;
  justify-content: center;
`
